import { render, staticRenderFns } from "./studentPortrait.vue?vue&type=template&id=ad5b69ac&scoped=true"
import script from "./studentPortrait.vue?vue&type=script&lang=js"
export * from "./studentPortrait.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/popUp.scss?vue&type=style&index=0&id=ad5b69ac&prod&lang=scss&scoped=true&external"
import style1 from "@/assets/css/table.scss?vue&type=style&index=1&id=ad5b69ac&prod&lang=scss&scoped=true&external"
import style2 from "./studentPortrait.vue?vue&type=style&index=2&id=ad5b69ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5b69ac",
  null
  
)

export default component.exports